module.exports = __webpack_public_path__ + "static/Hitradio_Oe3c-d3a59849f20f0c398365590078210dea.png";